<template>
  <div id="letter">

     <div class="top">
       <div class="logo"><img :src="log" alt=""></div>
       <div class="top-left">
         <div class="top-title">ARCFOX</div>
         <div class="top-sub-title">生而破界，探索不止</div>
       </div>
       <div class="top-download" @click="download">点击下载</div>
     </div>
     <div class="letter-bg">
        <img :src="bg" alt="">
     </div>
     <div class="contain">
        <div>
          <div class="vehicle-title">准车主 {{message.userName}}</div>
          <div class="vehicle-sub-title">邀您共赏爱车</div>
          <div class="vehicle-img">
            <img :src="message.carBackImg" alt="">
          </div>
          <div class="vehicle-type">{{message.carName}}</div>
          <div class="vehicle-desc">
            <span>{{message.mileage}}</span> | <span>{{message.color}}</span>
          </div>
      </div>
      <div class="sub-desc">- 想成为他/她的同款车友吗？-</div>
      <div>
          <div class="form-item">
            <input v-model="form.mobile" class="form-item-input" type="text" placeholder="请输入手机号" >
          </div>
          <div class="form-item" >
            <input maxlength="10" v-model="form.name" class="form-item-input" type="text" placeholder="请输入您的姓名" >
          </div>
          <div class="attention">注: 分享人将与您绑定推荐/助力购车关系。如您已有购车推荐/助力人，分享人将代替其成为您新的购车推荐/助力人。</div>
          <div @click="submit" class="submit" >提交</div>
      </div>
    </div>
    <sdialog ref="dialog">
        <div class="dialog-content">
            <div><img class="icon" :src="icon" alt=""></div>
            <div class="dialog-success">提交成功</div>
            <div class="dialog-desc">
                {{ dialogMessage }}
            </div>
            <div  class="download"><span @click="download">马上下载APP</span></div>
        </div>
    </sdialog>
  </div>
</template>
<script>
import dataServer from '@/api/data'
import sdialog from '@/components/dialog'
export default {
  components : {
      sdialog
  },
  data(){
    return {
      bg : require('./../assets/images/imgs/bg_letter_share.png'),
      icon : require('./../assets/images/imgs/icon_pup_tips@3x.png'),
      log : require('./../assets/images/imgs/weixin_icon_logo@3x.png'),
      message : {
        userName : '---',
        color : '---',
        carName : '---',
        mileage : '---',
        carBackImg : '',
      },
      form : {
        mobile : '',
        name : '',
        aid : '',
        userPhone : ''
      },
      dialogMessage: '下载ARCFOX极狐APP，并使用 您预留的手机号来登录'
    }
  },
  mounted() {
      this.getData()
  },
  methods: {
    blur(){
      setTimeout(function () {
        
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 500
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 10)
    },
    getData(){
        dataServer.findOrderByOrderId({ orderId : this.$route.query.orderId }).then((res) => {
            if(res.status == 'SUCCEED'){
                let data = res.data
                // if(data.vehicleModel == 'αS') {
                //   this.bg = require('./../assets/images/imgs/bg_letter_share_aS.png')
                // }
                Object.assign(this.message, {
                    carBackImg : data.carBackImg,
                    userName : data.buyUserName,
                    mileage : data.batteryIntroduce,
                    color : data.exteriorName,
                    carName : data.carName
                })
                this.form.aid = data.aid
                this.form.userPhone = data.buyUserPhone
            }
        })
    },
    submit(){
        
        if(this.form.mobile.trim() == ''){
          this.$toast({
            message: '手机号不能为空',
            duration: 1000,
          })
          return
        }
        if(!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.mobile.trim())){
          this.$toast({
            message: '请输入正确的手机号',
            duration: 1000,
          })
          return
        }
        if(this.form.name.trim() == ''){
          this.$toast({
            message: '姓名不能为空',
            duration: 1000,
          })
          return
        }
        dataServer.addShareReservation({ ...this.form }).then(res => {
            if(res.status == 'SUCCEED'){
              if (res.data == 'BIND_HELP'){
                this.dialogMessage = 'TA已成为你的购车助力人'
              } else if (res.data == 'BIND_REF'){
                this.dialogMessage = 'TA已成为你的购车推荐人'
              }
                this.$refs.dialog.show()
                Object.assign(this.form, {
                    mobile : '',
                    name : '',
                    userPhone : ''
                })
            }else{
              this.$toast({
                message: '提交失败',
                duration: 1000,
              })
            }
        })
    },
    download(){
      this.$router.push('/downPage')
    }
  },
}
</script>
<style lang="scss">
  #letter{
    position: relative;
    background-color: #161f30;
    .dialog-content{
        text-align: center;
        padding: 20px 0;
        .dialog-success{
            font-size: 18px;
            margin-top: 20px;
            margin-bottom: 5px;
        }
        .icon{
            width: 44px;
            height: 44px;
        }
        .dialog-desc{
            padding: 0 20px;
            padding-bottom: 30px;
            border-bottom: 1px solid #ccc;
            font-size: 18px;
            color: #333333;
        }
        .download{
            margin-top: 14px;
            color: #4798CB;
            font-size: 16px;
        }
    }
    .letter-bg{
      position: absolute;
      img{
        width: 100%;
      }
    }

    .attention{
      color: #999999;
      padding: 0 40px;
      font-size: 0.11rem;
      line-height: 0.18rem;
    }

    .contain{
      text-align: center;
      position: relative;
      z-index: 1;
      margin-top: 123px;
      left: 0;
      color: #FFFFFF;
      width: 100%;
    }

    .vehicle-title{
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
    }

    .vehicle-sub-title{
      font-size: 18px;
      margin-top: 10px;
      margin-bottom: 20px;
      line-height: 25px;
    }

    .vehicle-img{
      position: relative;
        text-align: center;
        margin: 0 auto;
        width: 279px;
        height: 162px;
        img{
          position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            width: 100%;
            height: auto;
        }
    }

    .vehicle-type{
      font-weight: bold;
      margin: 10px 0 5px 0;
      font-size: 20px;
      line-height: 28px;
    }

    .vehicle-desc{
      line-height: 20px;
    }

    .sub-desc{
      font-size: 18px;
      margin-top: 103px;
      line-height: 25px;
      margin-bottom: 10px;
    }

    .form-item{
      // display: flex;
      // align-items: center;
      // justify-content: center;
      height: 60px;
    }
    .form-item-input{
      // display: inline-block;
      box-sizing: border-box;
      background-color: transparent;
      color:#FFFFFF;
      width: 285px;
      height: 40px;
      padding: 10px;
      border: 1px solid #979797;
      border-radius: 4px;
      outline:none;
    }

    .submit{
      display: inline-block;
      width: 140px;
      height: 40px;
      font-size: 16px;
      margin-top: 20px;
      line-height: 40px;
      border-radius: 4px;
      background: linear-gradient(to right, #90C1E0, #4798CB);
    }

    ::-webkit-input-placeholder{
      color: #DDDDDD;
    }
    ::-moz-placeholder{
      color: #DDDDDD;
    }
    :-ms-input-placeholder{
      color: #DDDDDD;
    }
    .top{
      overflow: hidden;
      padding: 5px 0;
      background-color: rgba(245, 247, 250, 1);
      .logo{
        float: left;
        width: 40px;
        height: 40px;
        margin-left: 15px;
        img{
          width: 40px;
          height: 40px;
        }
      }
      .top-title{
        color: #333;
        font-size: 16px;
      }
      .top-sub-title{
        color: #666666;
        font-size: 12px;
      }
      .top-left{
        margin-left: 10px;
      }
    }
    .top-left{
      float: left;
    }
    .top-download{
      float: right;
    }
    .top-title{
      
    }
    .top-download{
      width: 72px;
      height: 30px;
      background-color: #4798CB;
      color: white;
      line-height: 30px;
      text-align: center;
      border-radius: 2px;
      margin-top: 5px;
      margin-right: 20px;
    }
  }
</style>
